import ProviderRating from './ProviderList';

export default ProviderRating;
